class mTileVideo extends HTMLDivElement {
    constructor() {
        super();
        this.videoEl = null;
        this.videoPollInterval = null;
    }

    connectedCallback() {
        const playEl = this.querySelector('.video-btn-play');
        if (playEl) {
            playEl.addEventListener('click', this.onClickPlayBtn.bind(this));
        }

        const fullscreenEl = this.querySelector('.video-btn-fullscreen');
        if (fullscreenEl) {
            fullscreenEl.addEventListener('click', this.onClickFullscreenBtn.bind(this));
        }

        const tileBtnEl = this.querySelector('.video-btn-tile');
        if (tileBtnEl) {
            tileBtnEl.addEventListener('click', this.onClickTile.bind(this));
        }

        // Freecaster's fcplayer.js injects the <video> inside .freecaster-player asynchronously
        this.videoEl = this.querySelector('video');
        if (this.videoEl) {
            this.setupVideoEl();
        } else {
            this.waitForVideoEl();
        }
    }

    disconnectedCallback() {
        if (this.videoPollInterval) {
            clearInterval(this.videoPollInterval);
        }
    }

    /**
     * Poll until fcplayer.js has injected its <video> element, then wire it up
     */
    waitForVideoEl() {
        this.videoPollInterval = setInterval(() => {
            this.videoEl = this.querySelector('video');
            if (this.videoEl) {
                clearInterval(this.videoPollInterval);
                this.setupVideoEl();
            }
        }, 250);
    }

    setupVideoEl() {
        this.videoEl.addEventListener('play', this.onVideoPlay.bind(this));
        this.videoEl.addEventListener('pause', this.onVideoPause.bind(this));
        this.videoEl.addEventListener('error', this.onVideoError.bind(this));
        this.updateVideoClasses();
    }

    /**
     * Check if video is currently playing
     * @returns {boolean} True if video is playing, false otherwise
     */
    isVideoPlaying() {
        return !!(
            this.videoEl.currentTime > 0 &&
            !this.videoEl.paused &&
            !this.videoEl.ended &&
            this.videoEl.readyState > 2
        );
    }

    togglePlayPause() {
        if (!this.videoEl) {
            return;
        }
        if (this.isVideoPlaying()) {
            this.videoEl.pause();
        } else {
            this.videoEl.play();
        }
    }

    /**
     * Update tile classes according to current video state
     */
    updateVideoClasses() {
        if (this.videoEl.error) {
            this.changeVideoClasses('error');
            return;
        }

        if (this.isVideoPlaying()) {
            this.changeVideoClasses('playing');
        } else {
            this.changeVideoClasses('paused');
        }
    }

    /**
     * Change tile classes according to states given
     * @param {string} videoState Video state. Value can be 'playing', 'paused' or 'error'
     */
    changeVideoClasses(videoState) {
        switch (videoState) {
            case 'playing':
                this.classList.add('video-playing');
                this.classList.remove('video-paused');
                this.classList.remove('video-error');
                break;
            case 'paused':
                this.classList.remove('video-playing');
                this.classList.add('video-paused');
                this.classList.remove('video-error');
                break;
            case 'error':
            default:
                this.classList.remove('video-playing');
                this.classList.remove('video-paused');
                this.classList.add('video-error');
        }
    }

    /**
     * Event handlers
     */

    onVideoPlay() {
        this.changeVideoClasses('playing');
    }

    onVideoPause() {
        this.changeVideoClasses('paused');
    }

    onVideoError() {
        this.changeVideoClasses('error');
    }

    onClickTile(event) {
        event.preventDefault();
        event.stopPropagation();
        this.togglePlayPause();
    }

    onClickPlayBtn(event) {
        event.preventDefault();
        event.stopPropagation();
        this.togglePlayPause();
        // Don't rely on the play/pause events, state can already have changed
        this.updateVideoClasses();
    }

    onClickFullscreenBtn(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dispatchEvent(new CustomEvent('fullscreen', {
            detail: { videoEl: this.videoEl }
        }));
    }
}

customElements.define('m-tile-video', mTileVideo, {
    extends: 'div'
});
